/** @jsxImportSource @emotion/react */
import React from 'react'
import {
  STATEMENT_NOT_MAILED_REASON_LABEL,
  StatementNotMailedDto,
  StatementNotMailedReason,
} from 'store/types'

type Props = {
  value: StatementNotMailedDto
  onChange: (value: StatementNotMailedDto) => void
}

export const isNotMailedValid = (value: StatementNotMailedDto) =>
  value.reason !== StatementNotMailedReason.OTHER || !!value.note?.trim()

export const NotMailedReasonFields: React.FC<Props> = ({ value, onChange }) => (
  <div css={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
    <select
      className="form-control form-control-sm"
      css={{ flex: '1 1 150px', maxWidth: 220 }}
      value={value.reason}
      onChange={(e) => onChange({ ...value, reason: e.target.value as StatementNotMailedReason })}>
      {Object.values(StatementNotMailedReason).map((reason) => (
        <option key={reason} value={reason}>
          {STATEMENT_NOT_MAILED_REASON_LABEL[reason]}
        </option>
      ))}
    </select>
    <input
      type="text"
      className={`form-control form-control-sm ${isNotMailedValid(value) ? '' : 'is-invalid'}`}
      css={{ flex: '2 1 150px' }}
      maxLength={1000}
      placeholder={value.reason === StatementNotMailedReason.OTHER ? 'Note (required)' : 'Note (optional)'}
      value={value.note || ''}
      onChange={(e) => onChange({ ...value, note: e.target.value })}
    />
  </div>
)
